import './index.scss'

import { addComponentToDOMById } from '$serverSrc/utils/component'

import EnterpriseAdminLoginForm from './components/EnterpriseAdminLoginForm'
import EnterpriseReport from './components/EnterpriseReport'

class App {
  constructor() {
    addComponentToDOMById(EnterpriseAdminLoginForm, 'EnterpriseAdminLoginForm')
    addComponentToDOMById(EnterpriseReport, 'EnterpriseReport')
  }
}

// Always export a 'new' instance so it immediately evokes:
export default new App()
